"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _cartApi = _interopRequireDefault(require("../../cartApi"));
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable no-case-declarations */
var _default = exports["default"] = function _default(type, payload, resolve, reject, providerId) {
  switch (type) {
    // case providerEvents.addToCart:
    //   break;
    case _providerEvents["default"].updateCartItem:
      var itemUuid = payload.uuid;
      var metadata = payload.metadata;
      var quantity = payload.quantity;
      _cartApi["default"].updateCartItem(itemUuid, metadata, quantity);
      break;
    case _providerEvents["default"].clearCart:
      _cartApi["default"].clearCart();
      break;
    case _providerEvents["default"].removeFromCart:
      var uuid = payload.uuid;
      _cartApi["default"].removeFromCart(uuid);
      break;
    case _providerEvents["default"].getCartItems:
      var options = payload.options;
      _cartApi["default"].getCartItems(providerId, Object.assign({}, options)).then(function (items) {
        resolve(items);
      });
      break;
    default:
      break;
  }
};
/* eslint-enable no-case-declarations */